import { ColumnConfigurationRenderAs } from '@april9au/stack9-sdk';

import { ListTable } from '../../components/ListTable/ListTable';

type Props = {
  id: number;
};
const AccountOrganisations = ({ id }: Props) => (
  <ListTable
    queryVars={{ accountId: id }}
    queryName="getorganisationbyaccount"
    title="Organisations"
    columns={[
      {
        label: 'Organisation number',
        field: 'org_number',
        renderAs: ColumnConfigurationRenderAs.Text,
        value: '{{org_number}}',
        options: {
          linkProp: '/crm/organisation-detail/{{id}}',
        },
      },
      {
        label: 'Registered name',
        field: 'registered_name',
        renderAs: ColumnConfigurationRenderAs.Text,
        value: '{{registered_name}}',
      },
      {
        label: 'Main industry',
        field: 'main_industry_name',
        renderAs: ColumnConfigurationRenderAs.Text,
        value:
          "{{[main_industry_code, main_industry_name].filter(Boolean).join(' - ')}}",
      },
      {
        label: 'Secondary industry',
        field: 'secondary_industry_name',
        renderAs: ColumnConfigurationRenderAs.Text,
        value:
          "{{[secondary_industry_code, secondary_industry_name].filter(Boolean).join(' - ')}}",
      },
      {
        label: 'Partner name',
        field: 'partner.registered_name',
        renderAs: ColumnConfigurationRenderAs.Text,
        value: '{{partner.registered_name}}',
      },
      {
        label: 'Payment waiver end date',
        field: 'payment_waiver_end_dt',
        renderAs: ColumnConfigurationRenderAs.Date,
        value: '{{payment_waiver_end_dt}}',
      },
      {
        label: 'Is active',
        field: 'is_active',
        renderAs: ColumnConfigurationRenderAs.EnumTags,
        value: '{{is_active}}',
        options: {
          enumColor: {
            Yes: 'green',
            No: 'red',
          },
        },
      },
    ]}
  />
);

export default AccountOrganisations;
